import { render } from "./ScreenerView.vue?vue&type=template&id=973a450e"
import script from "./ScreenerView.vue?vue&type=script&lang=js"
export * from "./ScreenerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__